import { createFileRoute, Navigate } from "@tanstack/react-router";
export const Route = createFileRoute("/_authed/settings/notifications")({ component: () => <Navigate to="/settings" replace /> });
